export default __webpack_public_path__ + "assets/models/b05f9cd36bbebc5585e4284cd6418b2e.glb";